import React from 'react';
import { useFormContext } from '@/providers';

export const ListingTypeSelect = () => {
    const { register, errors, fieldRefs } = useFormContext();


    return (
        <div className="grid grid-cols-1 p-4 bg-white rounded-lg">
            <h2 className="mb-4 text-2xl font-bold">Select Listing Type</h2>

            <div ref={(el) => (fieldRefs.current["listing_type"] = el)}>
                <label className="block mb-2 font-medium">Listing Type</label>
                <select {...register('listing_type')} className="w-full p-2 border border-gray-300 rounded input">
                    <option value="">Select a listing type</option>
                    <option value="short-term rental">Short-Term Rental</option>
                    {/* <option value="Long-Term Rental">Long-Term Rental</option> */}
                    <option value="Adventures" disabled>Adventures (Coming Soon)</option>
                </select>
                {errors.listing_type && <p className="mt-1 text-red-500">{errors.listing_type.message}</p>}
            </div>
        </div>
    );
};
